<template>
    <div>
        <allergy-form
            :is-allergy-form-sidebar-active.sync="isAllergyFormSidebarActive"
            :allergy-data="allergyData"
            @refetch-data="refetchAllergyData"
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                            variant="primary"
                            @click="updateAllergy()"
                         
                            >
                                <span class="text-nowrap">Add Allergy</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                ref="refAllergyListTable"
                :items="foodAllergies"
                responsive
                :fields="tableColumns"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No matching records found"
                :sort-desc.sync="isSortDirDesc"
                class="position-relative"
            >
                <template #cell(icon)="data">
                    <b-img
                        :src="data.item.icon?data.item.icon:require(`@/assets/images/no-image.png`)"
                        height="75"
                        width="75"
                        class="rounded m-0"
                    />
                </template>
                <template #cell(title)="data">
                    {{ data.item.title[currentLocale] }}
                </template>
                <template #cell(slug)="data">
                    {{ data.item.slug[currentLocale] }}
                </template>
                <template #cell(is_active)="data">
                    <b-badge
                        pill
                        :variant="`light-${resolveAllergyStatusVariant(data.item.is_active)}`"
                        class="text-capitalize"
                    >
                        {{ resolveAllergyStatusnameVariant(data.item.is_active) }} 
                    </b-badge>
                </template>
                <template #cell(action)="data">
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateAllergy(data.item)" variant="outline-success">Edit</b-button>
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(data.item.id)" variant="outline-danger">Delete</b-button>
                </template>
            </b-table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalFoodAllergies"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, 
        BFormCheckbox, BImg,
    } from 'bootstrap-vue';
    import draggable from 'vuedraggable'
    import { ref,onUnmounted } from '@vue/composition-api'
    import store from '@/store'
    import Ripple from 'vue-ripple-directive';
    import useAllergyList from './useAllergyList'
    import foodStoreModule from '../foodStoreModule'
    import AllergyForm from './AllergyForm.vue';
    // import { FeatherIcon, MenuIcon } from 'vue-feather-icons'

    export default {

        components: {
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox, 
            draggable, AllergyForm, BImg,
        },
        directives: {
            'b-modal': VBModal,
            Ripple
        },
        computed: {
            currentLocale() {
                return  this.$i18n.locale;
            },
        },
        setup(props, { emit }) {
            const STORE_MODULE_NAME = 'app-food';
            if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, foodStoreModule)
            onUnmounted(() => {
                if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
            });

            const {
                tableColumns,
                allergyData,
                isAllergyFormSidebarActive,
                refetchAllergyData,
                searchQuery,
                refAllergyListTable,
                foodAllergies,
                sortBy,
                isSortDirDesc,
                dataMeta,
                totalFoodAllergies,
                perPage,
                currentPage,
                allergies,
                fetchAllergyData,
                resolveAllergyStatusVariant,
                resolveAllergyStatusnameVariant,
                updateAllergy,
                deleteData,
            } = useAllergyList();

            fetchAllergyData()

            return {
                tableColumns,
                allergyData,
                isAllergyFormSidebarActive,
                refetchAllergyData,
                searchQuery,
                refAllergyListTable,
                foodAllergies,
                sortBy,
                isSortDirDesc,
                dataMeta,
                totalFoodAllergies,
                perPage,
                currentPage,
                allergies,
                fetchAllergyData,
                resolveAllergyStatusVariant,
                resolveAllergyStatusnameVariant,
                updateAllergy,
                deleteData,
            }
        },

        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete Allergy ID.'+id, {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if(value === true){
                            this.deleteData(id)
                        }
                    })

            },
        }
    }
</script>